import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import Progress from '../Progress';
import ProgressIndicator from '../ProgressIndicator';
const COMPONENT_NAME = 'ProgressBar';
const ProgressBar = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { progressClassName, indicatorClassName, displayPercentage, percentage, type } = props;
    const indicatorProps = {
        className: indicatorClassName,
        displayPercentage,
        percentage,
        type
    };
    return /*#__PURE__*/ React.createElement(Progress, {
        className: progressClassName
    }, /*#__PURE__*/ React.createElement(ProgressIndicator, indicatorProps));
};
ProgressBar.propTypes = {
    /**
	 * If true, percentage will be displayed
	 */ displayPercentage: PropTypes.bool,
    /**
	 * Custom `className` for the indicator.
	 */ indicatorClassName: PropTypes.string,
    /**
	 * Percentage
	 */ percentage: PropTypes.number,
    /**
	 * Custom `className` for the root.
	 */ progressClassName: PropTypes.string,
    /**
	 * One of [INFO, WARN, ERROR].
	 */ type: PropTypes.oneOf(ProgressIndicator.type.values())
};
export default ProgressBar;
